<div class="d-flex flex-column main-container">
    <div class="bold-text-small">{{ message }}</div>
    @for (row of samplesRows; track row; let i = $index; let isLast = $last) {
        <div class="d-flex flex-row">
            <div class="d-flex flex-row row-samples">
                @for (
                    sample of manualSamplesGroup.samples
                        | slice
                            : i * numberOfSamplesDisplayedPerRow
                            : (i + 1) * numberOfSamplesDisplayedPerRow;
                    track sample
                ) {
                    @if (isDateSamples()) {
                        <eff-date-picker
                            class="row-item"
                            [label]="sample.name"
                            [formController]="sample.formControl"
                            [minDate]="effectivenessModel.startDate"
                            [maxDate]="effectivenessModel.endDate"
                        ></eff-date-picker>
                    } @else {
                        <eff-input
                            class="row-item"
                            [type]="sampleType"
                            [label]="sample.name"
                            [formController]="sample.formControl"
                        ></eff-input>
                    }
                }

                @for (empty of lastRowEmptyItems(isLast); track empty) {
                    <div class="row-item"></div>
                }
            </div>
        </div>
    }
</div>
